export default __webpack_public_path__ + "static/media/soja_r3.da156e60.png";